import styled from "styled-components"

import Grid from '@material-ui/core/Grid'
import WorkOutlineIcon from '@material-ui/icons/WorkOutline'
import CloseIcon from '@material-ui/icons/Close'

import TypographyPro from "themes/TypographyPro"

import { respondAbove } from 'styles/mixins'

import SvgEditIcon from "components/common/EditIcon"
import ButtonBase from 'components/common/ButtonBase'

import Icon from '@mdi/react';
import { mdiMoped, mdiShoppingOutline, mdiMapMarker, mdiStorefrontOutline } from '@mdi/js';

// Localization drawer styled components

export const DeliveryIcon = () => <Icon path={mdiMoped} size="24px" color="var(--primary)" />
export const PickupIcon = () => <Icon path={mdiShoppingOutline} size="24px" color="var(--primary)" />
export const MapMarkerIcon = () => <Icon path={mdiMapMarker} size="24px" color="var(--primary)" />
export const StoreIcon = () => <Icon path={mdiStorefrontOutline} size="24px" color="var(--primary)" />


export const StyledStripeContainer = styled.div`
	display: block;
    width: 100%;
    div {
        margin: auto;
    }
`

// Localization header styled components

export const ToMenuButtonContainer = styled.div`
    ${respondAbove.lg`
        display: flex;
        justify-content: flex-end;
    `}
`

export const ToMenuButton = styled(ButtonBase)`
    span:first-child {
        display: flex;
        gap: 8px;
    }

    svg {
        width: 16px;
        height: 16px;
    }

    white-space: nowrap;
    width: 100%;

    ${respondAbove.lg`
        padding: 5px 35px;
        gap: 5px;
        width: auto;
    `}
`

export const OrderingIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    gap: 10px;
    width: 36px;
    height: 36px;

    white-space: nowrap;

    border-radius: var(--var-border-radius-btn, 60px);
    background: var(--grey-var-optional-background, #F5F5F5);

    ${respondAbove.lg`
        gap: 8px;
        padding: 0px 20px;
        width: auto;
        height: 40px;
    `}
`

export const OrderingIconText = styled(TypographyPro)`
    display: none;

    ${respondAbove.lg`
        display: block;
    `}
`

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
`

export const EditIcon = styled(SvgEditIcon)`
	width: 20px;
	height: 20px;    
    cursor: pointer;

	& path {
		fill: var(--fonts);
	}
`

export const Container = styled.div<{ref: any}>`
    position: relative;
    z-index: 1;
    padding: 20px;
    border-radius: 4px 4px 12px 12px;
    background-color: var(--clear);
    box-shadow: var(--defaultShadow1);

    ${respondAbove.sm`
        padding: 20px 40px;
	`}
`

export const GridContainer = styled(Grid)`
    max-width: 1280px;
    margin: auto;

    ${respondAbove.sm`
        gap: 40px;
        flex-wrap: nowrap;
	`}
`

export const StyledTextGrid = styled(Grid)<{ $alreadyLocalized: boolean }>`
    display: ${(props) => (props.$alreadyLocalized ? 'none' : 'flex')};
    margin-bottom: 20px;
    justify-content: center;

    ${respondAbove.sm`
        display: flex;
        margin-bottom: 0;
    `}
`

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--strokeMenuTitle);
`

export const OrderButton = styled.div`
    min-width: 300px;
    border-radius: var(--borderRadiusBtn);
    background-color: var(--primary);
    color: var(--clear);
    box-shadow: var(--defaultShadow1);
    cursor: pointer;

    display: flex;    
    justify-content: space-between;
    padding: 8px 20px;
    position: relative;

    :hover {
        background-color: var(--secondary);
    }

    ${respondAbove.sm`
        padding: 8px 40px;
    `}
`

export const OrderButtonStripeContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 56px;

    position: absolute;
    height: 47px;
    position: absolute;
    bottom: 0px;
    right: 40px;

    ${respondAbove.sm`
        right: 40px;
        height: 100%;
    `}
`

export const OrderButtonStripe = styled.div`
    background-color: var(--clear);
    width: 12px
`

export const LocalizedContainer = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    max-width: 1280px;
    flex: 1 0 0;

    margin: auto;
    justify-content: space-between;

    ${respondAbove.lg`
        gap: 40px;
        flex-direction: row;
	`}
`

export const LocalizedLeftContainer = styled.div`
    overflow: hidden;
`

export const LocalizedContent = styled.div`
    display: flex;
    gap: 20px;
    cursor: pointer;
`

export const LocalizedLeftContent = styled.div`
    display: flex;
    gap: 12px;
    overflow: hidden;
`

export const LocalizedLeftTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;
    color: var(--strokeMenuTitle);
`

export const LocalizedLeftTextLine = styled.div`
    display: flex;
    gap: 4px;
`

export const LocalizedTextLabel = styled(TypographyPro)`
    white-space: nowrap;
`

export const LocalizedLeftText = styled(TypographyPro)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

// Editing view styled components

export const EditingContainer = styled.div`
    padding-bottom: 60px;
`

export const EditingHeader = styled.div`
    display: flex;
    padding: 20px 20px 0 20px;
    justify-content: space-between;
    align-items: center;

    ${respondAbove.sm`
        padding: 40px 40px 0 40px;
	`}
`

export const EditingBody = styled.div`
    display: flex;
    padding: 40px 20px 0 20px;
    gap: 28px;
    flex-direction: column;

    ${respondAbove.sm`
        padding: 40px 40px 0 40px;
	`}
`

export const StyledCloseIcon = styled(CloseIcon)`
    width: 24px;
    height: 24px;
    cursor: pointer;
`

export const EditingRow = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;

    ${respondAbove.sm`
        gap: 28px;
	`}
`

export const EditingRowContainer = styled.div`
    display: flex;
    gap: 8px;
    flex-direction: column;
    width: -webkit-fill-available;
`

export const EditingRowTitle = styled(TypographyPro)`
    color: var(--inactive)
`

export const EditingRowSubTitle = styled.div`
    display: flex;
    gap: 4px;
    flex-direction: column;
`

export const EditingRowSubTitleRow = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`

export const EditingRowIconContainer = styled.div`
    flex-shrink: 0;
    display: flex;
    width: 24px;
`

export const EditingRowAction = styled.div<{ visible: boolean }>`
    display: flex;
    height: 35px;
    padding: 5px 16px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};

    border-radius: var(--borderRadiusBtn);
    border: 1px solid var(--primary);
    background: var(--clear);
`

export const EditingRowActionText = styled(TypographyPro)`
    color: var(--primary);
    cursor: pointer;
`

export const Divider = styled.div`
    height: 2px;
    background: var(--optionalBackground);
`